import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../mock';

export const LANGUAGES = [
  { code: 'de', label: 'Deutsch',     short: 'DE', flag: '🇨🇭' },
  { code: 'en', label: 'English',     short: 'EN', flag: '🇬🇧' },
  { code: 'ru', label: 'Русский',     short: 'RU', flag: '🇷🇺' },
  { code: 'vi', label: 'Tiếng Việt',  short: 'VI', flag: '🇻🇳' },
];

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('loewenherz_language');
    if (stored && translations[stored]) return stored;
    return 'de';
  });

  useEffect(() => {
    localStorage.setItem('loewenherz_language', language);
    if (typeof document !== 'undefined') {
      document.documentElement.lang = language;
    }
  }, [language]);

  const t = translations[language] || translations.de;

  // Backward compatibility: rotate through all available languages
  const toggleLanguage = () => {
    const idx = LANGUAGES.findIndex((l) => l.code === language);
    const next = LANGUAGES[(idx + 1) % LANGUAGES.length].code;
    setLanguage(next);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
